// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__yAfEX","leftMove":"Toggle_leftMove__tuclL","rightMove":"Toggle_rightMove__moX-5"};